import {useEffect, useRef, useState} from "react";
import "./checklistModal.css";
import {API_URL, SOCKET} from "../../../../../../../../URL";
import {useDispatch, useSelector} from "react-redux";
import {SET_CARD_CHECKLIST} from "../../../../../../../../store/constants";
import {BoardListsAPI} from "../../../../../../../../store/api/get/Board/Board";
export const ChecklistModal = ({onClose, position, card, setIsChecklistOpen}) => {
    const dispatch = useDispatch();
    const modalRef = useRef(null);
    const [title, setTitle] = useState("");
    const activeBoard = useSelector(state => state.boards.activeBoard);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);
    const sendCheckLists = async () => {
        const response = await fetch(API_URL + "/post/add_checklist/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                card_id: card.id,
                title,
            })
        });
        const data = await response.json();
        dispatch({type: SET_CARD_CHECKLIST, payload: data});

        setIsChecklistOpen(false);
        SOCKET.emit("add_checklist", data)
    }
    useEffect(() => {
        const f = (data) => {
            dispatch({type: SET_CARD_CHECKLIST, payload: data});
        };

        SOCKET.on("handle_board_card", f);

        return () => {
            SOCKET.off("handle_board_card", f);
        };
    }, [dispatch]);
    return (
        <div
            ref={modalRef}
            className="checklistModal"
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
                position: "fixed",
            }}
        >
            <div className="checklistModal__header">
                <h3 className="checklistModal__title">Checklist</h3>
                <button className="checklistModal__close" onClick={onClose}>✕</button>
            </div>

            <div className="checklistModal__body">
                <label className="checklistModal__label">Title</label>
                <input
                    type="text"
                    className="checklistModal__input"
                    placeholder="Checklist title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />

                <button className="checklistModal__createBtn" onClick={sendCheckLists}>
                    Add checklist
                </button>
            </div>
        </div>
    );
};